import { theme, ThemePaths } from "../../theme";
import getREMFromPX from "../../utils/getREMFromPX";

// Function to generate label styles with current theme
export const getLabelStyles = (themePath: ThemePaths) => {
  const colors = theme[themePath].colors;

  return `
  font-family: Inter;
  font-size: ${getREMFromPX(16)};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 8px;
  color: ${colors.form.primary};
  `;
};

// Default styles for cases when theme is not needed (like tests)
export const LabelStyles = `
font-family: Inter;
font-size: ${getREMFromPX(16)};
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: left;
margin-bottom: 8px;
color: #6d6d6d;
`;
